"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement("path", {
  d: "M15.07 4a.49.49 0 0 0-.36-.15.5.5 0 0 0-.35.14L3.44 14.91a.5.5 0 0 0 0 .71l4.94 4.94a.51.51 0 0 0 .36.15.49.49 0 0 0 .35-.15L20 9.65a.51.51 0 0 0 0-.71ZM2.43 16.8a.51.51 0 0 0-.84.24L.08 23.31a.49.49 0 0 0 .14.47.51.51 0 0 0 .47.14L7 22.41a.49.49 0 0 0 .36-.35.52.52 0 0 0-.12-.49ZM23.2 2.92 21.08.8a2.52 2.52 0 0 0-3.54 0l-1.41 1.42a.48.48 0 0 0 0 .7l4.95 5a.48.48 0 0 0 .7 0l1.42-1.47a2.5 2.5 0 0 0 0-3.53Z"
}), 'Pencil');

exports.default = _default;